import * as types from "./types";

export const getCompaniesListRequest = () => ({
  type: types.GET_COMPANIES_LIST_REQUEST,
});

export const openEditCompanyDrawer = (payload) => ({
  type: types.OPEN_EDIT_COMPANY_DRAWER,
  payload,
});

export const closeEditCompanyDrawer = () => ({
  type: types.CLOSE_EDIT_COMPANY_DRAWER,
});

export const updateCompanyRequest = (payload) => ({
  type: types.UPDATE_COMPANY_REQUEST,
  payload,
});

export const updateCompanySuccess = (payload) => ({
  type: types.UPDATE_COMPANY_SUCCESS,
  payload,
});

export const updateCompanyFailure = (payload) => ({
  type: types.UPDATE_COMPANY_FAILURE,
  payload,
});

export const deactivateCompanyRequest = (payload) => ({
  type: types.DEACTIVATE_COMPANY_REQUEST,
  payload,
});

export const deactivateCompanySuccess = (payload) => ({
  type: types.DEACTIVATE_COMPANY_SUCCESS,
  payload,
});

export const deactivateCompanyFailure = () => ({
  type: types.DEACTIVATE_COMPANY_FAILURE,
});

export const activateCompanyRequest = (payload) => ({
  type: types.ACTIVATE_COMPANY_REQUEST,
  payload,
});

export const activateCompanySuccess = (payload) => ({
  type: types.ACTIVATE_COMPANY_SUCCESS,
  payload,
});

export const activateCompanyFailure = () => ({
  type: types.ACTIVATE_COMPANY_FAILURE,
});

export const getCompaniesListSuccess = (payload) => ({
  type: types.GET_COMPANIES_LIST_SUCCESS,
  payload,
});

export const getCompaniesListFailure = (payload) => ({
  type: types.GET_COMPANIES_LIST_FAILURE,
  payload,
});

export const setCompaniesListSearch = (payload) => ({
  type: types.SET_COMPANIES_LIST_SEARCH,
  payload,
});

export const setCompaniesListFilters = (payload) => ({
  type: types.SET_COMPANIES_LIST_FILTERS,
  payload,
});

export const setCompaniesListPage = (payload) => ({
  type: types.SET_COMPANIES_LIST_PAGE,
  payload,
});

export const setCompaniesListPageSize = (payload) => ({
  type: types.SET_COMPANIES_LIST_PAGE_SIZE,
  payload,
});

export const resetCompaniesListFilters = () => ({
  type: types.RESET_COMPANIES_LIST_FILTERS,
});

export const getCompanyDetailsRequest = (payload) => ({
  type: types.GET_COMPANY_DETAILS_REQUEST,
  payload,
});

export const getCompanyDetailsSuccess = (payload) => ({
  type: types.GET_COMPANY_DETAILS_SUCCESS,
  payload,
});

export const getCompanyDetailsFailure = (payload) => ({
  type: types.GET_COMPANY_DETAILS_FAILURE,
  payload,
});

export const getCompanyEditRequestShowRequest = (payload) => ({
  type: types.GET_COMPANY_EDIT_REQUEST_SHOW_REQUEST,
  payload,
});

export const getCompanyEditRequestShowSuccess = (payload) => ({
  type: types.GET_COMPANY_EDIT_REQUEST_SHOW_SUCCESS,
  payload,
});

export const getCompanyEditRequestShowFailure = (payload) => ({
  type: types.GET_COMPANY_EDIT_REQUEST_SHOW_FAILURE,
  payload,
});

export const clearCompanyEditRequestDetail = () => ({
  type: types.CLEAR_COMPANY_EDIT_REQUEST_DETAIL,
});

export const patchCompanyEditRequestRequest = (payload) => ({
  type: types.PATCH_COMPANY_EDIT_REQUEST_REQUEST,
  payload,
});

export const patchCompanyEditRequestSuccess = () => ({
  type: types.PATCH_COMPANY_EDIT_REQUEST_SUCCESS,
});

export const patchCompanyEditRequestFailure = () => ({
  type: types.PATCH_COMPANY_EDIT_REQUEST_FAILURE,
});
